import { render } from "./JoinGroupModal.vue?vue&type=template&id=3fdba00e&scoped=true"
import script from "./JoinGroupModal.vue?vue&type=script&lang=js"
export * from "./JoinGroupModal.vue?vue&type=script&lang=js"

import "./JoinGroupModal.vue?vue&type=style&index=0&id=3fdba00e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fdba00e"]])

export default __exports__